export const SESSIONSTORAGE_TOKEN = 'jwttoken';
